<div class="modal-dialog-centered">
  <div class="modal-content p-4">
      <div class="mx-auto">
        <app-spinner-look-feel [size]="80"></app-spinner-look-feel>
      </div>
      <h2 class="mt-3 text-center" [innerHTML]="titulo"></h2>
      <h4 class="text-center" [innerHTML]="mensaje"></h4>
  </div>
</div>
